import { Badge } from '@/shared/components/ui/badge'
import { getRoleLabel } from '../constants/assignableRoles'

const ROLE_VARIANT: Record<string, 'accent' | 'info' | 'inactive' | 'pending'> = {
  ORG_OWNER: 'accent',
  ORG_MANAGER: 'info',
  ORG_ACCOUNTANT: 'info',
}

export function UserRoleBadge({ roleName }: { roleName: string }) {
  const variant = ROLE_VARIANT[roleName] ?? 'pending'
  // '' = miembro sin rol. Desde portal-correcciones-1 el listado ya no los
  // trae; el badge se queda como respaldo defensivo (backend viejo o un rol
  // desconocido), no como un estado que la pantalla espere pintar.
  return <Badge variant={variant}>{getRoleLabel(roleName) || 'Sin rol'}</Badge>
}
